// extracted by mini-css-extract-plugin
export var container = "Input_container__D4o0w";
export var dateInput = "Input_dateInput__NPQdz";
export var error = "Input_error__y759p";
export var errorMessage = "Input_errorMessage__jcKmW";
export var input = "Input_input__hPYPr";
export var md = "768px";
export var priceInput = "Input_priceInput__bPhDw";
export var shared = "\"../shared.module.css\"";
export var textArea = "Input_textArea__HMSRZ";
export var xl = "1200px";